<template>
  <Modal
    v-model="_value"
    width="500"
    title="销售渠道详细"
    @on-visible-change="visibleChange"
    >
    <Form ref="loginForm" :model="saleschannelinfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="saleschannelinfo.name":disabled="!modify"  placeholder="请输入销售渠道名称">
        </Input>
      </FormItem>
      <FormItem prop="telephoneNum">
        <Input v-model="saleschannelinfo.telephoneNum":disabled="!modify"  placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="saleschannelinfo.address":disabled="!modify"  placeholder="请输入联系地址">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'SaleschannelInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '销售渠道名称不能为空', trigger: 'blur' }
          ]
        }
      },
    },
    data() {
      return {
        modify: false,

        saleschannelinfo: {
          name:null,
          telephoneNum:null,
          address:null,
          lat:null,
          lng:null,
        }
      }
    },
    methods: {
      ...mapActions([
        'SalesChannelServ_AddObj',
        'SalesChannelServ_GetDetail',
        'SalesChannelServ_ModifyObj',
      ]),
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认销售渠道信息',
            content: '<p>确认销售渠道信息</p>',
            onOk: () => {
              store.dispatch('SalesChannelServ_ModifyObj', {
                params: this.saleschannelinfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              });
            },
            onCancel: () => {
              let saleschannelinfoId = this._initValue
              store.dispatch('SalesChannelServ_GetDetail', {
                params: {id: saleschannelinfoId}
              }).then(() => {
                this.saleschannelinfo = store.getters.get_SalesChannel_GetDetailResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          });
        }
      },
      visibleChange(val) {
        if(val){
          this.saleschannelinfo.name = null
          this.saleschannelinfo.telephoneNum = null
          this.saleschannelinfo.address = null
          this.saleschannelinfo.lat = null
          this.saleschannelinfo.lng = null
        }
        store.dispatch('SalesChannelServ_GetDetail', {
          params:{
          id: this._initValue
          }
        }).then(() => {
          this.saleschannelinfo = store.getters.get_SalesChannel_GetDetailResult
        }).catch(err => {
          this.$Message.error(err)
          this.$emit('on-fail');
        })
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
